export { default as LenisProvider, getLenisInstance, refreshLenis, scrollToWithLenis } from './LenisProvider'
